var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.sigle),function(sig,i){return _c('span',{key:i},[_vm._l((_vm.kontextData.filter((el) => el.sigle === sig)),function(d,idx){return _c('span',{key:idx,staticClass:"token mb-2 mr-2",class:{
        'mb-2': true,
        'mr-2': true,
        focustoken: _vm.focusTag === d.reihung && _vm.focusOrtho === d.ortho,
        token: _vm.focusTag !== d.reihung
      }},[_vm._v(" "+_vm._s(d.ortho)+" / "+_vm._s(d.sppos)+" / "+_vm._s(d.sigle)+" ")])}),_c('br')],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }